<template>
  <dl class="accordion box" role="presentation">
    <accordion-item
      v-for="(item, index) in contentArray"
      :multiple="multiple"
      :item="item"
      :category="item.title"
      :groupId="accordionId"
      :key="index"
      :itemID="index"
    />    
  </dl>
</template>

<script>
import accordionItem from './accordionItem'
export default {
  components: {        
    accordionItem
  },
  props: {
    content: {
      type: Array,
      required: true,
    },
    accordionId: {
      type: Number,
      default: 112,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      contentArray: [],
    };
  },
  mounted() {
    this.contentArray = this.content;
  },
};
</script>
